export default __webpack_public_path__ + "locales/lv/DeleteProfileEverDialog.json?hash=9c9a5395fcb09a9b6f991c8c142d5cd3";